const EventActionTypes = {
    SET_EVENT_ID: "SET_EVENT_ID",
    ADD_EVENTS: "ADD_EVENTS",
    SET_EVENT: "SET_EVENT",
};

export default EventActionTypes;
